export const video = () => {
  $('video')
    .on('play', function () {
      $(this).parent('.wp-block-video').addClass('is-playing');
    })
    .on('pause', function () {
      $(this).parent('.wp-block-video').removeClass('is-playing');
    })
    .on('stop', function () {
      $(this).parent('.wp-block-video').removeClass('is-playing');
    });
};
